import React from 'react';
import { cx } from './_cx';

/**
 * Button (UI primitive)
 *
 * Use this instead of ad-hoc inline button styles so sizing/spacing/colors stay
 * consistent across the app.
 */
export function Button({
  as,
  variant = 'primary', // primary | secondary | danger | sidebar
  active = false,
  className,
  disabled,
  type,
  ...props
}) {
  const Component = as || 'button';
  const isButtonEl = Component === 'button';

  // Only set `type` when rendering a <button>. Default to "button" to avoid
  // accidental form submissions.
  const resolvedType = isButtonEl ? (type || 'button') : undefined;

  return (
    <Component
      type={resolvedType}
      disabled={isButtonEl ? disabled : undefined}
      aria-disabled={!isButtonEl ? (disabled ? 'true' : undefined) : undefined}
      className={cx(
        'pv-btn',
        variant === 'primary' && 'pv-btn--primary',
        variant === 'secondary' && 'pv-btn--secondary',
        variant === 'danger' && 'pv-btn--danger',
        variant === 'sidebar' && 'pv-btn--sidebar',
        active && 'pv-btn--active',
        className
      )}
      {...props}
    />
  );
}

